import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar.component';
import { RouterModule } from '@angular/router';
import { SharedModules } from 'src/app/shared.modules';
//import { ToolbarService } from './toolbar.service';

@NgModule({
  declarations: [ToolbarComponent],
  exports: [ToolbarComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModules
  ],
  //providers: [ToolbarService]
})
export class ToolbarModule { }
